/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */

import React from 'react';
import { useToast } from "../contexts/ToastContext";
import { InputTextarea } from 'primereact/inputtextarea'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import apiClient from '../apis/PreventiviApi';

const ContactUs = () => {

const { showToast } = useToast();
    const handleClick = ()=>{
        debugger
        const nome = document.getElementById('nome').value
        const cognome = document.getElementById('cognome').value
        const email = document.getElementById('email').value
        const telefono = document.getElementById('telefono').value
        const messaggio = document.getElementById('messaggio').value
       // Regular expression for email validation
       const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

       if (nome === "" || cognome === "" || email === "" || telefono === "" || messaggio === "") {
           showToast({
               severity: "error",
               summary: "ERRORE",
               detail: "Tutti i campi sono obbligatori",
               life: 3000,
           });
       } else if (!emailRegex.test(email)) {
           showToast({
               severity: "error",
               summary: "ERRORE",
               detail: "Formato email non valido",
               life: 3000,
           });
        }else{

            apiClient.post('/inviaemailformcontatti',
                { "nome": nome, "cognome": cognome, "email": email, "telefono": telefono, "messaggio": messaggio },
                { 
                    headers: { 'Content-Type': 'application/json' } 
                })
                .then(() => {
                    
                    showToast({
                        severity: "success",
                        summary: "Messaggio inviato",
                        detail: "Grazie per averci contattato, ti risponderemo al più presto",
                        life: 3000,
                      });
        
                   
                })
                .catch(error => {
                    showToast({
                        severity: "error",
                        summary: "ERRORE",
                        detail: error,
                        life: 3000,
                    });
                })










            
        }
        
    }
    return (
    <div id="contatti" className="surface-ground">
        <div className="grid grid-nogutter">
            <div className="col-12 md:col-6 bg-no-repeat bg-cover p-3 md:p-8" style={{ backgroundImage: "url('assets/immagini/contact-2.jpg')" }}>
                <div className="text-white text-2xl font-medium mb-6">Contattaci</div>
                <div className="text-gray-300 line-height-3 mb-6">Contattateci oggi stesso per iniziare il vostro viaggio di trasformazione. </div>
                <a href="https://maps.app.goo.gl/aGwpgqvCMiBkP6Hb6" target="_blank" className="inline-flex align-items-center text-blue-300 font-bold no-underline cursor-pointer">
                    <span className="mr-3">Guarda la nostra sede su Google Maps</span>
                    <i className="pi pi-arrow-right"></i>
                </a>
                <ul className="list-none p-0 m-0 mt-6 text-white">
                    <li className="flex align-items-center mb-3">
                        <i className="pi pi-whatsapp mr-2"></i>
                        
                        <a className='text-white' onClick={()=>window.open("https://wa.me/393284874103", "_blank")} >(+39) 3284874103</a>
                    </li>
                   
                    <li className="flex align-items-center">
                        <i className="pi pi-inbox mr-2"></i>
                        <span className="text-white">info@mnediliziaristrutturazione.com</span>
                    </li>
                </ul>
            </div>

            <div className="col-12 md:col-6 grid">
                <div className="p-fluid formgrid grid px-4 py-8 md:px-6">
                    <div className="field col-12 lg:col-6 mb-4">
                        <InputText id="nome" type="text" className="py-3 px-2 text-lg" placeholder="Nome" />
                    </div>
                    <div className="field col-12 lg:col-6 mb-4">
                        <InputText id="cognome" type="text" className="py-3 px-2 text-lg" placeholder="Cognome" />
                    </div>
                    <div className="field col-12 mb-4">
                        <InputText id="email" type="text" className="py-3 px-2 text-lg" placeholder="Email" />
                    </div>
                    <div className="field col-12 mb-4">
                        <InputText id="telefono" type="text" className="py-3 px-2 text-lg" placeholder="Telefono" />
                    </div>
                    <div className="field col-12 mb-4">
                        <InputTextarea id="messaggio" rows="3" autoResize className="py-3 px-2 text-lg" placeholder="Messaggio" />
                    </div>
                    <div className="col-12 text-right">
                        <Button type="button" label="Invia"  onClick={()=>handleClick()} icon="pi pi-envelope" className="px-5 py-3 w-auto" />
                    </div>
                     
            </div>
        </div>
    </div>
    </div>
    )
}
export default ContactUs